<template>

    <TemplateBasic 
      v-bind:breadcrumb="breadcrumb"
      v-bind:permission="permission">

      <h3>Manual Stop Bill Email</h3>
      
      <AppForm
        ref="pageForm" 
        v-bind:formParameter="PARAM"
        v-bind:permission="permission"
        v-on:form-change="onFormChange" >

      </AppForm>

      <TemplateFeedback ref="pageFeedback" />

      <TemplateButton v-on:click="onSaveButtonClick" type="button" class="btn btn-success" >
        Submit
      </TemplateButton>

    </TemplateBasic>

</template>

<script>
import TemplateBasic from "@/components/Template/TemplateBasic";
import TemplateButton from "@/components/Template/TemplateButton";
import TemplateModal from "@/components/Template/TemplateModal";
import TemplateFeedback from "@/components/Template/TemplateFeedback";
import AppForm from "@/components/App/AppForm";
import validation from "@/components/Utility/Validation"
import helper from "@/components/Utility/Helper"

var querystring = require('querystring');

const PARAM = [
  {
    key: 'carparkID',
    text: 'Car Park',
    form_select: {
      data: [],
      formatSelectOptionValue: (data) => data.id, 
      formatSelectOptionText: (data) => data.carparkCode ? `${data.carparkCode} - ${data.name}` : data.name,
    },
    form_chosen: true,
  },
  {
    key: 'licenseID',
    text: 'Parking License',
    form_select: {
      data: [],
      formatSelectOptionText: option => {
        let text = helper.plFormPLNum(option.licenseOperatorNum, option.carparkID);
        let customer = option['_customer'];
        text += customer ? ` - ${customer.name} (${customer.nationalID})` : '';
        return text;
      },
    },
    form_chosen: true,
  },
  {
    key: '_lease',
    text: 'Subscription',
    // form_label_attr: { style: 'display:none'},
    form_select: {
      data: [],
      formatSelectOptionText: option => {
        if(typeof option === 'string') {
          return option;
        }
        if(option['all']) {
          return option['all']
        }
        let text = `${option['seasonName']} - ${option['parkerName']} `;
        // if(option['isParkAide']) {
        //   text += '(Passcard: ParkAide Blocked)';
        //   if(new moment() > helper.parseDateTime(option['commencementDate'])) {
        //     if(!option['isBlock']) {
        //       text += '(Passcard: ParkAide Active)';
        //     }
        //   }
        // } else {
        //   text += option['leasePasscard'] ? '(Passcard: ' + option['leasePasscard'] + ')' : '';
        // }
        return text;
      },
    },
    form_edit_hide: true,
    form_input_attr: { 'multiple' : true },
    form_chosen_multiple: true,
  },
  {
    key: '_date',
    text: 'Billing Month',
    form_default: helper.formatDate(new moment().startOf('month').unix()),
    form_datepicker: {
      beforeShowDay: function(date) {
        return true//date.getDate() === 1;
      },
    },
  },
];

const PARAM_MAP = helper.transformParamToMap(PARAM);

export default {
  name: "PageManualStopBillEmail",
  components: {
    TemplateBasic,
    TemplateButton,
    TemplateFeedback,
    TemplateModal,
    AppForm,
  },
  data () {
    return {
      permission : null,
      breadcrumb : [
        { name: 'Home', url: helper.WEB_URL },
        { name: 'Adminstration' },
        { name: 'Manual Stop Bill Email' },
      ],

      PARAM,
      PARAM_MAP,
    }
  },
  mounted() {
    if(!helper.hasViewPermission(this.permission = helper.getPermission(this))) {
      return;
    }
    
    this.$refs['pageForm'].setForm(true);
    this.hideFormFromKey('carparkID');
    this.loadCustomer();
  },
  methods: {
    hideFormFromKey(key) {
      this.pageShowAdd = false;
      this.pageShowEdit = false;

      if(key === null) {
        this.pageShowAdd = true;
        this.pageShowEdit = true;
      }

      let hide = false;
      this.PARAM.forEach(parameter => {
        if(parameter.key === key) {
          hide = true;
        }

        if(hide) {
          parameter.form_hide = hide;
          return;
        }

        if(parameter.key === 'accessCard') {
          if(this.$refs['pageForm'].formData['applicationType'] === 'Personal') {
            parameter.form_hide = false;
          } else {
            parameter.form_hide = true;
          }
          return;
        }

        parameter.form_hide = hide;
      });
    },
    loadCustomer() {
      this.$refs['pageFeedback'].setFeedbackLoading('Loading profile data...');
      this.$http
        .get(
          helper.SERVER_URL + '/api2/customer',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.pageCustomer = response.data;
          this.loadCarpark();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'profile data'));
        });
    },
    loadCarpark() {
      this.$refs['pageFeedback'].setFeedbackLoading('Loading car park data...');
      this.$http
        .get(
          helper.SERVER_URL + '/api2/carpark',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();

          this.pageCarpark = response.data
          response.data = response.data.filter(k => {
            if(!k['isEnable']) {
              return false;
            }
            if(k['SuspendApplication']) {
              return false;
            }
            if(k['endDate'] && helper.parseDateTime(k['endDate']) <= moment().startOf('day')) {
              return false;
            }
            return true;
          });

          helper.inputSelectSetOption(this.PARAM_MAP['carparkID'], response.data);
          let formData = this.$refs['pageForm'].formData;
          formData['carparkID'] = this.$route.query.carparkID || formData['carparkID'];
          formData['licenseID'] = this.$route.query.licenseID || formData['licenseID'];
          this.hideFormFromKey('licenseID');
          if(formData['carparkID']) {
            this.loadLicense();
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'car park data'));
        });
    },
    loadLicense() {
      this.hideFormFromKey('licenseID');
      let formData = this.$refs['pageForm'].formData;

      let url = helper.SERVER_URL;
      url += '/api2/carpark/' + formData['carparkID'] + '/license/';

      let feedbackItem = 'parking license data'
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          let tempData = response.data[0];
          if(tempData) {
            // TODO kw1 only show active license & lease
            if(this.$refs['pageForm'].formIsAdd) {
              response.data = response.data.filter(k => k.status === 'Pending' || k.status === 'Active');
            }

            this.pageLicense = response.data;

            response.data.forEach(k => {
              k['_carpark'] = this.pageCarpark.find(j => j.id === k.carparkID);
              k['_customer'] = this.pageCustomer.find(j => j.id === k.customerID);
            });

            helper.inputSelectSetOption(this.PARAM_MAP['licenseID'], response.data);
            this.hideFormFromKey('_lease');
            if(formData['licenseID']) {
              this.loadLease()
            }
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No ' + feedbackItem + ' available');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'license data'));
        })
    },
    loadLease() {
      this.hideFormFromKey('_lease');
      let formData = this.$refs['pageForm'].formData;

      let url = helper.SERVER_URL;
      url += '/api2/license/' + formData['licenseID'] + '/lease/';

      let feedbackItem = 'parking license subscription data'
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          let tempData = response.data[0];
          if(tempData) {
            // TODO kw1 only show active license & lease
            // if(this.$refs['pageForm'].formIsAdd) {
            //   response.data = response.data.filter(k => k.status === 'Pending' || k.status === 'Active');
            // }

            this.pageLease = response.data;

            response.data.forEach(k => {
              k['_carpark'] = this.pageCarpark.find(j => j.id === k.carparkID);
              k['_customer'] = this.pageCustomer.find(j => j.id === k.customerID);
            });

            helper.inputSelectSetOption(this.PARAM_MAP['_lease'], [].concat({'all': 'All Subscription'}, response.data));
            this.hideFormFromKey(null);

            this.$refs['pageFeedback'].setFeedbackMessage();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No ' + feedbackItem + ' available');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },

    onSaveButtonClick() {

      if(!this.$refs['pageForm'].validateForm()) {
        let formData = this.$refs['pageForm'].formData;
        formData['date'] = helper.parseDateTime(formData['_date']).unix();

        if(!formData['_lease'] || formData['_lease'].length === 0) {
          return
        }

        this.$refs['pageFeedback'].setFeedbackLoading('Sending stop bill email');
        this.$http
          .post(
            helper.API_URL + '/api2/license/stopBillEmail',
            querystring.stringify(formData),
            helper.createAxiosFormConfig()
          )
          .then(response => {
            let resultMeta = helper.processAxiosResponse(this, response);
            this.$refs['pageFeedback'].setFeedbackMessage('Successfully trigger stop bill email on ' + helper.formatDate(formData['_date']) + '. ' + response.data);
            return true;
          })
          .catch(error => {
            this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'trigger', 'stop bill email'));
          })
      }
    },

    onFormChange(formData, parameter) {
      if(parameter.key === 'carparkID') {
        this.loadLicense();
      } else if(parameter.key === 'licenseID') {
        this.loadLease();
      }
    },

    hasAddOrEditPermission() {
      if(this.pageIsAdd) {
        return helper.hasAddPermission(this.permission);
      } else {
        return helper.hasEditPermission(this.permission);
      }
    },
    hasDeletePermission() {
      return helper.hasDeletePermission(this.permission);
    },
    
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Page/Manual/PageManualStopBillEmail.vue